import './delivery-address';
import onDOMContentLoaded from '../../../base/util/dom/onDOMContentLoaded';

onDOMContentLoaded(() => {
    const root = document.querySelector('.firb__account-index');
    if (!root) {
        return;
    }
});